var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_12519_21458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_308_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7905 14.4366C11.4707 16.7565 7.69604 16.7563 5.37621 14.4366C3.05639 12.1167 3.05639 8.34205 5.37621 6.02223C7.47 3.92839 10.7489 3.7247 13.0736 5.41055L10.3861 8.09807L20 9.79541L18.3026 0.181641L15.6666 2.8176C13.9559 1.40833 11.8285 0.641644 9.58331 0.641644C7.02233 0.641644 4.61462 1.63896 2.80369 3.44982C-0.934565 7.18814 -0.934565 13.2707 2.80369 17.009C4.61462 18.82 7.02233 19.8172 9.58331 19.8172C12.1443 19.8172 14.552 18.8199 16.3629 17.009L16.7631 16.6089L14.1906 14.0365L13.7905 14.4366ZM17.566 2.51912L18.6041 8.39961L12.7236 7.36143L17.566 2.51912ZM9.58336 18.6853C7.32472 18.6853 5.20122 17.8057 3.60417 16.2087C0.307239 12.9117 0.307239 7.54718 3.60417 4.25019C5.20128 2.65308 7.32472 1.77354 9.58336 1.77354C11.5258 1.77354 13.368 2.42461 14.8616 3.62261L13.8825 4.60176C11.1082 2.47945 7.11181 2.68591 4.57579 5.22192C1.81464 7.98307 1.81464 12.4759 4.57579 15.237C7.2023 17.8635 11.3955 17.9917 14.1748 15.6213L15.1493 16.5957C13.6079 17.9473 11.6524 18.6853 9.58336 18.6853Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c3445a9eee0ed130dfb230b89dab3c3d.svg";
export { ForwardRef as ReactComponent };